// extracted by mini-css-extract-plugin
export var actionButton = "_e2-0";
export var fileInput = "_e2-2";
export var paperclip = "_e2-1";